import { render, staticRenderFns } from "./proof-toggle.vue?vue&type=template&id=5eb72b6a&scoped=true&"
import script from "./proof-toggle.vue?vue&type=script&lang=js&"
export * from "./proof-toggle.vue?vue&type=script&lang=js&"
import style0 from "./proof-toggle.vue?vue&type=style&index=0&id=5eb72b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb72b6a",
  null
  
)

export default component.exports